import { render, staticRenderFns } from "./brandV2.vue?vue&type=template&id=c8060800&scoped=true"
import script from "./brandV2.vue?vue&type=script&lang=js"
export * from "./brandV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8060800",
  null
  
)

export default component.exports